import { render, staticRenderFns } from "./WorldSubMenu.vue?vue&type=template&id=4fa3f198&scoped=true&"
import script from "./WorldSubMenu.vue?vue&type=script&lang=js&"
export * from "./WorldSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./WorldSubMenu.vue?vue&type=style&index=0&id=4fa3f198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa3f198",
  null
  
)

export default component.exports